<template>
  <div class="recurring-card-info">
    <div class="header-container">
      <Skeletor
        height="54px"
        class="skeletonTag rounded-lg mb-4"
        width="200px"
      />
    </div>
    <div class="info-holder">
      <div class="left-column">
        <div class="fundraiser-image">
          <Skeletor
            height="144px"
            width="288px"
            class="rounded-lg mb-4"
          ></Skeletor>
        </div>
        <div>
          <div class="amount-raised">
            <Skeletor
              width="150px"
              height="24px"
              class="rounded-lg"
            ></Skeletor>
          </div>
          <Skeletor
            width="288px"
            height="10px"
            class="rounded-lg"
          ></Skeletor>
        </div>
        <div>
          <div style="display: flex; justify-content: space-between; margin: 8px 0">
            <div>
              <Skeletor
                height="40px"
                width="140px"
                class="rounded-lg"
              ></Skeletor>
            </div>
            <div>
              <Skeletor
                height="40px"
                width="140px"
                class="rounded-lg"
              ></Skeletor>
            </div>
          </div>
          <div style="margin: 16px 0">
            <Skeletor
              height="40px"
              width="288px"
              class="rounded-lg"
            ></Skeletor>
          </div>
          <div style="height: 48px; margin: 16px 0">
            <Skeletor
              height="40px"
              width="288px"
              class="rounded-lg"
            ></Skeletor>
          </div>
        </div>
      </div>
      <div class="details">
        <div class="tabs">
          <div class="tab font-20 weight-600">Fundraiser Details</div>
          <div class="tab font-20 weight-600">Donations</div>
        </div>
        <div>
          <div class="tabs-holder">
            <div class="weight-400 font-14">Benefitting Organization</div>
            <div>
              <Skeletor
                height="16px"
                width="200px"
                class="rounded-lg mb-4"
              ></Skeletor>
            </div>
            <div class="weight-400 font-14 flex">
              <span>Fundraiser URL</span>
            </div>
            <div>
              <Skeletor
                height="16px"
                width="240px"
                class="rounded-lg mb-4"
              ></Skeletor>
            </div>
            <div class="weight-400 font-14">Gives Day Event</div>
            <Skeletor
              height="16px"
              width="250px"
              class="rounded-lg mb-4"
            ></Skeletor>
            <div class="weight-400 font-14">Created On</div>
            <Skeletor
              height="16px"
              width="200px"
              class="rounded-lg mb-4"
            ></Skeletor>
            <div class="weight-400 font-14">End Date</div>
            <Skeletor
              height="16px"
              width="180px"
              class="rounded-lg mb-4"
            ></Skeletor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.left-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px 12px 32px 0;
}

.fundraiser-image {
  width: 288px;
  height: 144px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
}

.amount-raised {
  width: 240px;
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.details {
  width: 560px;
  padding: 24px 60px 40px 60px;
}

.tabs {
  width: 561px;
  margin: 0;
  display: flex;
  justify-content: center;
  gap: 20px;
}
.tabs-holder {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  background: #ffffff;
  width: 100%;
  padding: 24px 60px 40px 60px;
  width: 561px;
}
.tab {
  cursor: pointer;
  margin: 10px;
}

.header {
  margin-bottom: 0px;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 0;
}
.info-holder {
  display: flex;
}

@media (max-width: 1288px) {
  .info-holder {
    flex-direction: column;
    align-items: flex-start;
  }
  .left-column {
    margin: 32px 0;
    flex-direction: row;
  }
  .details {
    padding: 0;
  }
}

@media (max-width: 1024px) {
  .info-holder {
    align-items: center;
    justify-content: space-around;
  }
  .previous-screen {
    justify-content: center;
  }
  .header {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;
  }
  .header-container {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .left-column {
    flex-direction: column;
  }
  .info-holder {
    flex-direction: column;
    align-items: center;
  }
  .details {
    padding-bottom: 80px;
  }
  .tabs {
    width: 325px;
    flex-wrap: wrap;
  }
  .donations-container {
    width: 335px;
  }
  .tabs-holder {
    width: 335px;
  }
  .details {
    width: 335px;
  }
}
</style>
